import type { ReactNode } from 'react';
import React, { createContext, useContext, useMemo } from 'react';

export interface AnalyticsData {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
}

interface AnalyticsDataContextType {
	data: AnalyticsData;
}

const AnalyticsDataContext = createContext<AnalyticsDataContextType>({ data: {} });

interface AnalyticsDataProviderProps {
	children: ReactNode;
	data?: AnalyticsData;
}

export const AnalyticsDataProvider: React.FC<AnalyticsDataProviderProps> = ({
	children,
	data = {},
}) => {
	const parentContext = useContext(AnalyticsDataContext);

	const mergedData = useMemo(
		() => ({
			...parentContext.data,
			...data,
		}),
		[parentContext.data, data],
	);

	const contextValue: AnalyticsDataContextType = useMemo(
		() => ({
			data: mergedData,
		}),
		[mergedData],
	);

	return (
		<AnalyticsDataContext.Provider value={contextValue}>{children}</AnalyticsDataContext.Provider>
	);
};

export const useAnalyticsData = (): AnalyticsData => {
	const context = useContext(AnalyticsDataContext);
	return context.data;
};
